<template>
  <ul
    class="pagination flex-wrap flex justify-center nmr-10 nml-10 list pl-0"
    style="min-width: 303px"
  >
    <li
      class="flex items-center h-37 lh-15 pl-16 pr-16 mr-18 mb-20 br-14 bd-1 bg-white bd-gray-medium hand gray-dark fw-700 fs-12 button-arrow"
      :class="{ disabled: currentPage === 1 }"
      @click="prev"
    >
      <router-link :to="currentPage - 1 > 0 ? createLink(currentPage - 1) : ''" class="flex items-center">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.0909 8.18182L7.70254 8.18182L9.57854 6.30581L8.42146 5.14873L4.57019 9L8.42146 12.8513L9.57854 11.6942L7.70254 9.81818L13.0909 9.81818L13.0909 8.18182Z" fill="#5C5C5C"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M9 -7.86805e-07C13.9706 -3.52265e-07 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 3.52265e-07 13.9706 7.86805e-07 9C1.22135e-06 4.02944 4.02944 -1.22135e-06 9 -7.86805e-07ZM9 1.63636C4.93318 1.63636 1.63637 4.93317 1.63636 9C1.63636 13.0668 4.93318 16.3636 9 16.3636C13.0668 16.3636 16.3636 13.0668 16.3636 9C16.3636 4.93318 13.0668 1.63636 9 1.63636Z" fill="#5C5C5C"/>
        </svg>
        <template v-if="windowWidth > PHONE">
          <span class="ml-8">Previous</span>
        </template>
      </router-link>
    </li>
    <li
      class="bd-1 bd-transparent ml-2 mr-2 mb-20 lh-37 w-37 h-37 tc br-p-50 gray-dark hand fw-700 fs-12"
      v-for="(link, index) in links"
      :key="index"
      :class="{
        'bd-blue-branding bg-blue-200 fw-900': currentPage == link,
        disabled: isNaN(link),
      }"
      v-on:click="go(link)"
    >
      <router-link v-if="!isNaN(link)" :to="createLink(link)">
        {{ link }}
      </router-link>
      <span v-else>
        {{ link }}
      </span>
    </li>
    <li
      @click="next"
      class="flex items-center h-37 lh-15 pl-16 pr-16 ml-18 mb-20 br-14 bd-1 bg-white bd-gray-medium hand gray-dark fw-700 fs-12 button-arrow"
      :class="{ disabled: currentPage === totalPage }"
    >
      <router-link :to="currentPage +1 > totalPage ? '' : createLink(currentPage+1)" class="flex items-center">
<!--        <img class="w-18 h-18" src="https://s3-cdn.designerjourneys.com/static/icons/icon-arrow-right.svg" alt="arrow-right" />-->
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.90909 9.81818L10.2975 9.81818L8.42146 11.6942L9.57854 12.8513L13.4298 9L9.57854 5.14873L8.42146 6.30581L10.2975 8.18182L4.90909 8.18182V9.81818Z" fill="#D0D0D0"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18ZM9 16.3636C13.0668 16.3636 16.3636 13.0668 16.3636 9C16.3636 4.93318 13.0668 1.63636 9 1.63636C4.93318 1.63636 1.63636 4.93318 1.63636 9C1.63636 13.0668 4.93318 16.3636 9 16.3636Z" fill="#D0D0D0"/>
        </svg>
        <template v-if="windowWidth > PHONE">
          <span class="ml-8">Next</span>
        </template>
      </router-link>
    </li>
  </ul>

  <div
    class="tc gray-dark wp-100 mb-60 fs-12 fw-400 lh-15"
    style="min-width: 303px"
  >
    <b class="fw-700">{{ from }} – {{ to }} </b> of {{ totalRecord }}
    {{ textRecord }}
  </div>
</template>

<script>
import { ref, computed, watch, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useRouterUtils } from '~/helper/useRouterUtils'
import { PHONE } from '~/constant/common'
import { useGeneralInfoStore } from '~/store/pinia/generalInfo'
export default {
  emits: ['action', 'update:currentPage'],
  props: {
    currentPage: {
      required: true,
      type: Number,
      default: 1,
    },
    limit: {
      type: Number,
      default: 5,
    },
    totalRecord: {
      required: true,
      type: Number,
      default: 0,
    },
    totalPage: {
      required: true,
      type: Number,
      default: 0,
    },
    textRecord: {
      type: String,
      default: '',
    },
    perPage: {
      required: true,
      type: Number,
      default: 15,
    },
    from: {
      required: true,
      type: Number,
      default: 1,
    },
    to: {
      required: true,
      type: Number,
      default: 15,
    },
  },

  setup(props, { emit }) {
    const route = useRoute()
    const router = useRouter()
    const generalStore = useGeneralInfoStore()
    
    const windowWidth = computed(
      () => generalStore.generalData.windowWidth,
    )
    const current = ref(1)

    const { updatePathQuery } = useRouterUtils()

    function rangePage(start, end) {
      let tempArr = ref([])
      for (let i = start - 1; i < end; i++) {
        if (pages.value[i]) {
          tempArr.value.push(pages.value[i])
        }
      }
      return tempArr.value
    }

    let limitPage = computed(() => {
      return props.limit - 1
    })

    let pages = computed(() => {
      let pages = ref([])
      for (let i = 1; i <= props.totalPage; i++) {
        pages.value.push(i)
      }

      return pages.value
    })

    let links = computed(() => {
      let first = ref([1, '...'])
      let last = ref(['...', props.totalPage])
      let range = ref([])
      if (windowWidth.value < PHONE) {
        return
      } else {
        if (props.totalPage < 8) {
          return rangePage(1, props.totalPage)
        } else {
          if (props.currentPage <= limitPage.value) {
            range.value = rangePage(1, limitPage.value + 1)
            return props.currentPage + range.value.length <= props.totalPage
              ? range.value.concat(last.value)
              : range.value
          } else if (props.currentPage > props.totalPage - limitPage.value) {
            range.value = rangePage(
              props.totalPage - limitPage.value,
              props.totalPage,
            )
            return props.currentPage - range.value.length >= 1
              ? first.value.concat(range.value)
              : range.value
          } else {
            range.value = rangePage(
              props.currentPage - Math.ceil(limitPage.value / 2 - 1),
              props.currentPage + Math.ceil(limitPage.value / 2 - 1),
            )
            return first.value.concat(range.value).concat(last.value)
          }
        }
      }
    })

    watch(
      () => props.currentPage,
      (value) => {
        updatePathQuery(router, { page: value })
      },
    )

    const prev = () => {
      if (props.currentPage > 1) {
        current.value = props.currentPage
        current.value--
        updatePathQuery(router, { page: current.value })
        emit('update:currentPage', current.value)
        emit('action')
      }
    }

    const next = () => {
      if (props.currentPage < props.totalPage) {
        current.value = props.currentPage
        current.value++
        updatePathQuery(router, { page: current.value })
        emit('update:currentPage', current.value)
        emit('action')
      }
    }

    const go = (page) => {
      if (isNaN(page)) {
        return
      }
      updatePathQuery(router, { page })
      emit('update:currentPage', page)
      emit('action')
    }

    // const onResize = () => {
    //   if (window.innerWidth < PHONE) {
    //     checkMobile.value = true;
    //   } else {
    //     checkMobile.value = false;
    //   }
    // }

    onMounted(() => {
      // window.addEventListener('resize', onResize)
      // window.addEventListener('load', onResize)
      if(props.currentPage > props.totalPage) {
          updatePathQuery(router, { page: 1 })
          emit('update:currentPage', 1)
        }
      current.value = +route.query.page || 1
    })

    watch(() => props.currentPage, (value) => {
      if (value > props.totalPage) {
        updatePathQuery(router, { page: 1 })
        emit('update:currentPage', 1)
      }
    })

    const createLink = (text) => {
      let qs = Object.keys(route.query);
      if (qs.indexOf('page') === -1){
        qs.push('page');
      }
      qs = qs.map((key) => {
        if (key === 'page') {
          return `${key}=${text}`
        }
        return `${key}=${route.query[key]}`
      })
      .join('&');
      return `${route.path}?${qs}`
    }

    return { prev, next, go, links, windowWidth, createLink , PHONE }
  },
}
</script>

<style lang="scss" scoped>
// .pagination li:hover {
//   background: #f1f1f1;
// }
.disabled {
  // cursor: not-allowed;
  pointer-events: none;

}
.button-arrow {
  svg {
    path {
      fill: #5c5c5c;
    }
  }
  &.disabled {
    svg {
      path {
        fill: #d0d0d0;
      }
    }
  }
}

ul{
  li {
    a {
      color: #5c5c5c;
    }
  }
}
</style>
